import _slicedToArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect, createElement, Fragment } from "react";
/** React component that renders its children client-side only / after first mount */

export var ClientOnly = function ClientOnly(_ref) {
  var children = _ref.children;
  var hasMounted = useClientOnly();

  if (!hasMounted) {
    return null;
  }

  return createElement(Fragment, {
    children: children
  });
};
/** React hook that returns true if the component has mounted client-side */

export var useClientOnly = function useClientOnly() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasMounted = _useState2[0],
      setHasMounted = _useState2[1];

  useEffect(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
};